import React,{useRef,useEffect} from 'react';
import { emptyCheck, numCheck} from './toolFunction';
/*

modify 20210104 因為輸入法種類太多，所以第一次使用Composition事件來合理處置，只是不知道WIN10上面正不正常
*/
function InputText(props){  
   let isOnComposition = false; 
   const inputRef=useRef("");
  
   const setInputValue = () => { 
       //console.log(props.inputState)
       inputRef.current.value = (props.inputState || ' ').trimStart() || ' ' ;   
    };

    useEffect(() => {   setInputValue()   });

   const handleComposition = evt => {
    //console.log('evt.target.value:'+evt.target.value)
    //console.log(evt.type)
    if (evt.type === 'compositionend') {       
      isOnComposition = false;      
      //console.log(navigator.userAgent)
    //   if (navigator.userAgent.indexOf('Chrome') > -1 || navigator.userAgent.indexOf('Trident') > -1  || navigator.userAgent.indexOf('Firefox')>-1
    //   ) {
    //      //console.log('Chrome')
    //       handleChange(evt);
    //   }
      handleChange(evt);
      return;
    }
   
    isOnComposition = true;
    
  };
    
    const handleChange= event => {
        console.log('event.target.value isOnComposition_before:'+event.target.value)
        //props.inputName, props.stateObj, props.checkValue, props.title, props.required
        if (!isOnComposition) {           
            //console.log('handleChange:'+isOnComposition)
            //console.log('event.target.value isOnComposition_after:'+event.target.value)
            let word = event.target.value.trimStart();
            //console.log('word00:'+word)
            if(event.target.value.length >0){ 
                if (props.required === true){
                    word = emptyCheck(word, props.title, props.stateObj.state[props.inputName])
                    //console.log('word01:'+word)
                }
            } else { word = " ";
             //console.log('word03:'+word)
             }  

            if (props.required === false && event.target.value.length === 0) { word = " "};
            word = numCheck(word, props.checkValue,props.title ); 
            //console.log('word04:'+word)
           
            props.stateObj.setState({ ...props.stateObj.state, [props.inputName]: word});
        }
       
    }   

    const commonProps = {
        onChange: handleChange,  
        onCompositionStart: handleComposition,   
        onCompositionUpdate: handleComposition,   
        onCompositionEnd: handleComposition,
      };

   
    return(
        <div className="form-row">
            <label>
                { props.required && <span className='text-danger'>*</span> } 
                { props.title } 
                <em className='text-primary'>{props.notice} </em>
            </label>
            <input  type="text" className={`form-control`} id={props.inputName} placeholder={props.title}  ref={inputRef}  {...commonProps}   />
           
            {
            
            /*
            value={props.inputState} 原本value 和 是事件
             onChange={handleChange(props.inputName, props.stateObj, props.checkValue, props.title, props.required)} 

            props.required &&
                <div className="invalid-feedback">
                    {props.title}不可以空白
                </div>*/
            }

        </div>
            
    )
}

export default InputText;